// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"386":"stencil-polyfills-css-shim","465":"stencil-polyfills-dom"}[chunkId] || chunkId) + "." + {"212":"69c48c50","320":"c35d93b0","386":"9098c8ed","465":"55a152b3","604":"3390ea7e","616":"ebcb7b48","875":"7e373113","950":"39370d7c"}[chunkId] + ".chunk.js";
};